import ShareModal from '@/components/referral/ShareModal';
import { useUserProvider } from '@/context/UserProvider';
import { fetchInsReferralLink } from '@/lib/service/anonymously';
import React, { useState } from 'react';
import AcceptInviteModal from '@/components/referral/AcceptInviteModal';
import { Button, message } from 'antd';
import { useTranslation } from 'next-i18next';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';

interface IData {
  title: string;
  subTitle: string;
  desc: string;
  buttonText: string;
  headCard: string;
}

export default function Hero({ data, inviteCode }: { data: IData; inviteCode?: string }) {
  const { title, subTitle, desc, buttonText, headCard } = data;
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const [isAcceptInviteModalOpen, setIsAcceptInviteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  function handleAcceptInvite() {
    if (!isLogin) {
      onOpenLoginModal(true);
    } else {
      setLoading(true);
      fetchInsReferralLink(inviteCode)
        .then((res) => {
          switch (res.code) {
            case 0:
              setIsAcceptInviteModalOpen(true);
              ga_logEvent(EventName.referral_invitee_claim);
              break;
            case 10001:
              message.warning(t('Looks like you’ve already claimed a coupon—you can’t claim another one.'));
              break;
            case 10002:
              message.warning(t('The referral link you used isn’t valid.'));
              break;
            case 10003:
              message.warning(t('Sorry, you can’t use your own referral link to claim a coupon.'));
              break;
            case 10004:
              message.warning(t('This offer isn’t available for existing subscribers.'));
              break;
            default:
              break;
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  return (
    <section className="flex flex-col items-center pt-[110px] max-md:pt-8 max-w-[800px] px-4 mx-auto primary-text">
      <div
        className="bg-[#E9E5FF] text-xl py-3 px-8 rounded-full leading-[1]"
        dangerouslySetInnerHTML={{
          __html: headCard,
        }}
      />
      <h1
        className="font-bold text-[64px] max-md:text-[42px] pt-[42px] text-center"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      <div
        className="text-2xl max-md:text-base text-center pt-6 primary-text-60"
        dangerouslySetInnerHTML={{
          __html: subTitle,
        }}
      />
      <Button
        type="primary"
        shape="round"
        loading={loading}
        className="text-lg h-14 w-full max-w-[450px] mt-[56px]"
        onClick={() => {
          if (inviteCode) {
            handleAcceptInvite();
          } else {
            setIsShareModalOpen(true);
          }
        }}
      >
        {buttonText}
      </Button>
      <div className="pt-12 text-sm primary-text-60">{desc}</div>
      <ShareModal isModalOpen={isShareModalOpen} onClose={() => setIsShareModalOpen(false)} />
      <AcceptInviteModal isModalOpen={isAcceptInviteModalOpen} onClose={() => setIsAcceptInviteModalOpen(false)} />
    </section>
  );
}
